import { render, staticRenderFns } from "./PromptAdmin.vue?vue&type=template&id=e9fbf326&scoped=true&"
import script from "./PromptAdmin.vue?vue&type=script&lang=ts&"
export * from "./PromptAdmin.vue?vue&type=script&lang=ts&"
import style0 from "./PromptAdmin.vue?vue&type=style&index=0&id=e9fbf326&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9fbf326",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VBtn,VDataTable,VSelect,VTextField,VTextarea})
